export default {
  setAllAdvertisements(state, advertisements) {
    state.advertisements = advertisements
  },
}
